"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.stop.recording': 'Stop Recording',
};
